module.exports = __webpack_public_path__ + "static/media/ff-amula.5a90dd58.jpg";